import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../core/browser-providers';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';
import { Environment } from '../../environments/enviroment.model';
import { TranslateService } from '../core/translate.service';
import { UpdateEventService } from '../shared-services/update-event.service';
import { MediaService } from '../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../shared-components/modals/dialog.service';
import { GenericListComponent, Page, HasAction, Actions } from '../shared-components/generic-list/generic-list.component';
import { SecurityService } from '../security/security.service';
import { TiposEnvio } from './tiposEnvio.model';


interface Filters {
  description: string;
  page: number;
  size: number;
  search?: string;
}

@Component({
  selector: 'app-tiposEnvio-list',
  templateUrl: './tiposEnvio-list.component.html',
  styleUrls: ['./tiposEnvio-list.component.scss']
})
@Injectable()
export class TiposEnvioListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private backendUrl: string;

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'description',  label: 'Descripcion' },
    { name: 'costo', label: 'Costo de envío' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  public hasActions: HasAction;

  tiposEnvioFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  tiposEnvioList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const tiposEnvioPromise = this.backendService.get(TiposEnvio, TiposEnvio.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const tiposEnvio = await tiposEnvioPromise;
        return tiposEnvio;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.tiposEnvioFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<TiposEnvio[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api+'/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_MOTIVOS_RECHAZO'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_MOTIVOS_RECHAZO'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.tiposEnvioList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshTiposEnvioList();
  }


  refreshTiposEnvioList() {
    this.tiposEnvioList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshTiposEnvioList();
  }

  onSearch(searchText) {
    this.filters.search = 'description:' + searchText;
    this.refreshTiposEnvioList();
  }

  clearSearch() {
      this.refreshTiposEnvioList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAddTiposEnvio() {
    this.router.navigate(['/tiposEnvio/agregar']);
  }


  onEditTiposEnvio(role: TiposEnvio) {
    this.router.navigate(['/tiposEnvio/editar', role.id]);
  }


  async onDeleteTiposEnvio(tiposEnvio: TiposEnvio) {

    this.dialogService.confirm('Eliminar tipo de envío',
    '¿Está seguro que desea eliminar el tipo de envío ' + tiposEnvio.description + '?')
    .then( res => {
      if (res) {
        this.deleteTiposEnvio(res, tiposEnvio);
      }
    });

  }

  async deleteTiposEnvio(res, tiposEnvio: TiposEnvio) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(TiposEnvio.path + tiposEnvio.id);
        this.snackService.success('Motivos de rechazo eliminados correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshTiposEnvioList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshTiposEnvioList();
  }

  removeChip(event) {
    this.refreshTiposEnvioList();
  }

}



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio-list.component.ts